import { useCallback } from 'react';

import { AssertionException } from '../../../utils/log';
import { Guid } from '../../model/guid';
import { isNonSequencedFlowItem, isQuiz, isSequencedFlowItem } from '@ael/core-api';
import {
    ExpandSubmenus,
    SelectedNonSequencedFlowItemAction,
    SelectedQuiz,
    SelectedSequencedFlowContentItemAction
} from '../../../actions/menuActions';
import {getSequencedFlowStructureSelector} from '../../selectors/getSequencedFlowStructureSelector';
import {removeQuizCompletedItems} from '../student/tracking/itemsTrackingActions';
import {getItemByIdSelector, getParentSubmenuItemsListByChildSelector} from './itemsSelectors';
import {useStudentDispatch} from '../../../hooks/useStudentDispatch';
import {useStudentSelector} from '../../selectors/useStudentSelector';

export const useSelectItem = () => {
  const getItemById = useStudentSelector((state) => getItemByIdSelector(state));
  const getParentList = useStudentSelector((state) => getParentSubmenuItemsListByChildSelector(state));
  const dispatch = useStudentDispatch();

  const getSequencedFlowStructure = useStudentSelector(getSequencedFlowStructureSelector);

  const goToItem = useCallback(
    (itemId: Guid) => {
      const item = getItemById(itemId);
      const parentsList = getParentList(item.id);
      dispatch(ExpandSubmenus(parentsList));
      if (isNonSequencedFlowItem(item)) {
        dispatch(SelectedNonSequencedFlowItemAction(item));
        return;
      }
      if (isSequencedFlowItem(item)) {
        dispatch(SelectedSequencedFlowContentItemAction(item, getSequencedFlowStructure(item.id)));
        return;
      }
      if (isQuiz(item)) {
        dispatch(removeQuizCompletedItems(item));
        dispatch(SelectedQuiz(item));
        return;
      }

      throw AssertionException('Unexpected item type.');
    },
    [getItemById, getParentList, dispatch, getSequencedFlowStructure]
  );

  return {
    goToItem,
  };
};
